import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";

const defaultValues = { pin: '' };
const schema = yup.object().shape({
    pin: yup.string()
        .min(4, 'PIN must be exactly 4 characters')
        .max(4, 'PIN must be exactly 4 characters')
});

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 3,
};

const PinModal = ({ openPin, handlePinModal, handlePinValue }) => {
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onSubmit",
        defaultValues,
        resolver: yupResolver(schema),
    });

    const onSubmit = (data) => {
        handlePinValue(data.pin);
        handlePinModal(false);
    };

    if (!openPin) return;
    return (
        <div>
            <Modal
                open={openPin}
                onClose={() => handlePinModal(false)}
            >
                <Box sx={style}>
                    <form className="w-full flex flex-col gap-2" onSubmit={handleSubmit(onSubmit)} >
                        <div className='flex justify-between items-center'>
                            <Typography className="w-[40%] text-[20px] custom-font" sx={{ fontWeight: '700' }}> Enter PiN<sup className="text-red-700">*</sup> </Typography>

                            <Controller control={control}
                                name="pin"
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        required
                                        type='password'
                                        error={!!errors.pin}
                                        helperText={errors?.pin?.message}
                                        size='small'
                                        id="Kirtan_Title_Sulekh"
                                        className="w-full my-2"
                                        autoComplete="off"
                                    />
                                )} />
                        </div>
                        <div className='flex justify-start'>
                            <Button type='submit'
                                size='small'
                                className='' variant="contained" color="primary" onClick={handleSubmit(onSubmit)}>
                                Submit
                            </Button>
                        </div>
                    </form>
                </Box>
            </Modal>
        </div>
    );
};
export default PinModal;
